import React, { useState, useEffect } from 'react'

//-- components
import { useStateProps ,useImageProps ,useFormatProps } from '../ImpaasComponents.js';
import ImageLoader from '../ImageLoader.tsx';
import ImageSaver from '../ImageSaver.tsx';
import FormatSelect from '../FormatSelect.tsx';

//-- ui
import { Collapse, Select ,InputNumber ,Checkbox ,Alert } from "antd";

//-- css
import './ResizeApp.css';

//! ***
const { round ,max } = Math;
 
const resolutionMap = {
  "8K": [7680,4320]
  ,"5K": [5120,2880]
  ,"4K": [4096,2160]
  ,"2K": [2048,1080]
  ,"UHD 2160p": [3840,2160]
  ,"WQHD 1440p": [2560,1440]
  ,"FHD 1080p": [1920,1080]
  ,"HD 720p": [1280,720]
  ,"qHD 540p": [960,540]
  ,"WXGA 4:3": [1280,960]
  ,"XGA 4:3": [1024,768]
  ,"SVGA 4:3": [800,600]
  ,"VGA 4:3": [640,480]
  ,"QVGA 4:3": [320,240]
};

function findResolutionByValue(width: number ,height: number) : string|null {
  for( const [key,value] of Object.entries(resolutionMap) ) {
      if( value[0] === width && value[1] === height ) {
          return key;
      }
  }

  return null;
}

//! *** Main Component ***
export default function ResizeApp(props) {

//-- ImPaaS component
      const { hasStateChanges ,onStateChanges ,isQueuing ,adviseDownload ,adviseQueuing } = useStateProps(props);
      const { noImage ,hasImage ,imageUrl ,imageInfoHeader ,imageWidth ,imageHeight ,onImageUpload } = useImageProps(props);
      const { formatName ,formatSelect } = useFormatProps(props);
  
//-- IMAGE
    function getClientDims(e: HTMLElement): { width: number; height: number } {
      return {
          width: e.clientWidth,
          height: e.clientHeight
      };
    }

    function getClientDimsById(id: string): { width: number; height: number } {
      const e = document.getElementById(id) as HTMLElement;

      return getClientDims(e);
    }

    function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
      // const { width, height } = e.currentTarget;

      setSizeX( imageWidth );
      setSizeY( imageHeight );
  
      onStateChanges(false);
    }

//-- PARAMETERS

    //-- named resolutions
    const [namedResolution, setNamedResolution] = useState('Original');

    function updateNamedResolution() {
      const res = findResolutionByValue( sizeX ,sizeY );

      if( res ) {
        setNamedResolution( res );
      } else {
        setNamedResolution( "Custom" );
      } 
    }

    const onNamedResolutionChange = (value: string) => {
      switch( value ) {
        case 'Original':
          setSizeX(imageWidth);
          setSizeY(imageHeight);
          break;

        case 'Custom':
          break;

        default:
          const sz = resolutionMap[value];
          setSizeX( sz[0] );
          setSizeY( sz[1] );

          if( (sz[0]/sz[1]).toFixed(4) !== (imageWidth/imageHeight).toFixed(4) ) {
            deselectAspect();
          }

          break;
      };

      onStateChanges( value !== 'Original' );
    }

    //-- requested size
    const [sizeX, setSizeX] = useState("");
    const [sizeY, setSizeY] = useState("");
    
    //-- preview scale
    const [scaleX, setScaleX] = useState(1) //! negative used for mirror H
    const [scaleY, setScaleY] = useState(1) //! negative uses for mirror V

    //! this runs whenever sizeX or sizeY is changed (with current value for sizeX,sizeY)
    useEffect(() => {
      if( hasImage ) {
        const dims = getClientDimsById("resize-canvas");

        const w = max(dims.width,imageWidth); //! reference width
        const h = max(dims.height,imageHeight); //! reference height
        const gScale = 1 / max( 1 ,max( sizeX/w ,sizeY/h ) );

        setScaleX( gScale * sizeX / imageWidth );
        setScaleY( gScale * sizeY / imageHeight );
        updateNamedResolution();
      }
    }, [sizeX,sizeY]); 

    const onSizeChange = (name: string, value: string) => {
      const v = parseInt(value);

      switch( name ) {
        case 'width':
          setSizeX(v); if( keepAspect ) { setSizeY( Math.round(v * imageHeight() / imageWidth()) ); }
          break;
        case 'height':
          setSizeY(v); if( keepAspect ) { setSizeX( Math.round(v * imageWidth() / imageHeight()) ); }
          break;
      }

      onStateChanges(true);
    }

    //-- aspect
    const [keepAspect ,setKeepAspect] = useState<boolean>(true);
    const [flashAspect, setFlashAspect] = useState(false);

    function deselectAspect() {
      if( !keepAspect ) return;

      setKeepAspect(false);
      setFlashAspect(true);

      setTimeout(() => {
        setFlashAspect(false);
      }, 3000); // 3 seconds for 3 flashes
    }

    useEffect(() => {
      if( hasImage && keepAspect ) {
        setSizeY( round(sizeX * imageHeight / imageWidth) );
        updateNamedResolution();
      }
    }, [keepAspect]);

    //-- resize method
    const [scaleMethod, setScaleMethod] = useState('Cubic');

//-- COMPONENT
    const { Panel } = Collapse;
    const { Option } = Select;

    const resolutions = Object.entries(resolutionMap).map(([label, value]) => (
      <Option key={label} value={label}>
          {label} ({value.join('x')})
      </Option>
    ));
 
    return (
        <div className="ResizeApp">
            <div class="upload-container">
              {!!imageUrl && (
                  <>
                  <div style={{textAlign: 'left' }}>
                      <Alert message={imageInfoHeader} type="info" showIcon />
                  </div>
                  <div class="canvas-container">
                      <div class="resize-canvas" id="resize-canvas">
                          <img 
                              alt="Resize"
                              src={imageUrl}
                              style={{ transform: `scaleX(${scaleX}) scaleY(${scaleY})` }}
                              onLoad={onImageLoad}
                          />
                      </div>
                  </div>
                  </>
              )}
              <hr/>
              <div class="container-fluid d-flex justify-content-between align-items-center">
                  <div class="container-fluid d-flex justify-content-center">
                  {!isQueuing && (
                    <ImageLoader onUpload={onImageUpload}/>
                  )}
                  {!isQueuing && hasImage && (
                    <button disabled={!hasStateChanges} type="button" class="process-button"> Apply </button>
                  )}
                  <ImageSaver enabled={hasImage} queueTime="5" onDownload={adviseDownload} onQueue={adviseQueuing}/>                    
                  </div>
              </div>
            </div>
            
            <div class="method-group">
                <ul class="property-list">
                <Collapse defaultActiveKey={['1','2']}>
                  <Panel header={<h6>Size</h6>} key="1" className="property-panel">
                    <input type="hidden" name="named_resolution" value={namedResolution} />
                    <Select value={namedResolution} style={{ width: 220 }}
                      disabled={noImage}
                      onChange={onNamedResolutionChange}
                    >
                      <Option value="Original">Original</Option>
                      {resolutions}
                      <Option value="Custom">Custom</Option>
                    </Select>
                    
                    <label>Width:</label>
                    <InputNumber<number>
                      name="size_width" min={0} max={7680} step={10} 
                      disabled={noImage} value={sizeX} onChange={(value) => onSizeChange("width",value)}
                    />
                    <label>Height:</label>
                    <InputNumber<number>
                      name="size_height" min={0} max={4320} step={10} 
                      disabled={noImage} value={sizeY} onChange={(value) => onSizeChange("height",value)}
                    />

                    <Checkbox disabled={noImage} checked={keepAspect} name="keep_ratio"
                      onChange={(event) => setKeepAspect(event.target.checked)}
                      className={flashAspect ? 'flashing' : ''}
                    >
                      Keep Ratio
                    </Checkbox>

                    <label>Resize Method:</label>
                    <input type="hidden" name="scale_method" value={scaleMethod} /> 
                    <Select disabled={noImage} defaultValue="Cubic" style={{ width: 120 }} onChange={(value) => setScaleMethod(value)}>
                      <Option value="nearest">Nearest</Option>
                      <Option value="linear">Linear</Option>
                      <Option value="area">Area</Option>
                      <Option value="cubic">Cubic</Option>
                      <Option value="lanczos">Lanczos</Option>
                      <Option value="reshape">Reshape</Option>
                    </Select>                    
                  </Panel>

                  <Panel header={<h6>Format</h6>} key="2" className="property-panel">
                    <FormatSelect enabled={hasImage} name={formatName} onSelect={formatSelect} />
                  </Panel>
                </Collapse>
                </ul>      
            </div>
        </div>
    )
}